import request from '@/utils/request'

export function getItem (param) {
  return request({
    url: '/item/find',
    method: 'get',
    params: param
  })
}
export function getItemByCategory (data) {
  return request({
    url: '/item/category',
    method: 'post',
    data
  })
}
export function getItemRecommend (data) {
  return request({
    url: '/item/recommend',
    method: 'post',
    data
  })
}
export function getItemHotcakes (data) {
  return request({
    url: '/item/hotcakes',
    method: 'post',
    data
  })
}
export function searchItem (data) {
  return request({
    url: '/item/search',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/item.js